import type { ChartTheme } from './types';
import { palette } from './tokens';

export const chartThemeDark: ChartTheme = {
  background: 'transparent',
  textColor: palette.text,
  fontSize: 11,
  axis: {
    domain: { line: { stroke: palette.border, strokeWidth: 1 } },
    ticks: {
      line: { stroke: palette.border, strokeWidth: 1 },
      text: { fontSize: 11, fill: palette.text },
    },
    legend: {
      text: { fill: palette.text },
    },
  },
  grid: { line: { stroke: palette.surfaceElev, strokeWidth: 1 } },
  tooltip: {
    container: {
      background: 'var(--anl-surface-elev)',
      color: 'var(--anl-text)',
      border: `1px solid var(--anl-border)`,
      borderRadius: 6,
      boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)',
      padding: 12,
    },
  },
};
